import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import Grid from "@mui/material/Grid2";
import Dashboard from "../dashboard/dashboard";

export default function SplashPage(props) {
  // Get data from Redux store for dashboard widgets
  const { facilities } = useSelector((state) => state.organization, isEqual);
  const devicesStore = useSelector((state) => state.devices, isEqual);
  const assetsStore = useSelector((state) => state.assets, isEqual);
  
  // Get assets from the store
  const assets = assetsStore?.lastEvents || assetsStore?.assets || [];
  const devices = devicesStore?.devices || [];

  return (
    <Grid container>
      <Grid size={12}>
        <Dashboard 
          {...props} 
          assets={assets}
          devices={devices}
          facilities={facilities || {}}
        />
      </Grid>
    </Grid>
  );
}